module.exports = __webpack_public_path__ + "img/finished-bottom.143ce2f6.png";